export default {
  brand: "A&A MOTORS",
  tagline: "كل قيادة. كل أسلوب حياة.",
  slogan: "كل السيارات. كل الأساليب. اسم واحد.",
  nav: {
    fleet: "الأسطول",
    noDeposit: "بدون وديعة",
    how: "كيف نعمل",
    about: "من نحن",
    faq: "الأسئلة الشائعة",
    contact: "تواصل معنا",
    book: "احجز سيارتك",
    menu: "القائمة",
    close: "إغلاق",
  },
  hero: {
    eyebrow: "تأجير سيارات في دبي",
    line1: "كل قيادة.",
    line2: "كل أسلوب حياة.",
    sub: "من قيادات يومية إلى تجارب استثنائية.",
    ctaFleet: "استكشف أسطولنا",
    ctaBook: "احجز سيارتك",
    scroll: "مرّر للأسفل",
  },
  categories: {
    all: "جميع السيارات",
    economy: "سيارات اقتصادية",
    everyday: "سيارات يومية",
    sedans: "سيدان",
    suv: "دفع رباعي",
    luxury: "سيارات فاخرة",
    sports: "سيارات رياضية",
    supercars: "سيارات خارقة",
  },
  fleet: {
    eyebrow: "التشكيلة",
    title: "أسطولنا",
    sub: "تشكيلتنا الحالية — المزيد من السيارات قادم قريباً. يتم تأكيد التوفر والأسعار عند الاستفسار.",
    priceOnRequest: "السعر عند الطلب",
    perDay: "/ اليوم",
    seats: "مقاعد",
    transmission: "ناقل الحركة",
    viewDetails: "عرض التفاصيل",
    enquire: "استفسر الآن",
    noDeposit: "بدون وديعة متاح",
    onRequest: "عند الطلب",
    available: "متاح",
    unavailable: "غير متاح",
    sort: "ترتيب حسب",
    sortFeatured: "مميز",
    sortName: "الاسم أ–ي",
    sortPriceAsc: "السعر: من الأقل",
    sortPriceDesc: "السعر: من الأعلى",
    noDepositOnly: "المؤهلة بدون وديعة",
    showAll: "عرض جميع السيارات",
    noResults: "لا توجد سيارات مطابقة لهذا الفلتر.",
    sampleNote: "يتم دائماً تأكيد التوفر والمواصفات والسعر النهائي من فريقنا قبل الحجز.",
    loading: "جارٍ تحميل الأسطول…",
    loadError: "تعذر تحميل الأسطول. يرجى المحاولة مرة أخرى.",
    retry: "إعادة المحاولة",
  },
  modal: {
    specs: "المواصفات",
    engine: "المحرك",
    acceleration: "0–100 كم/س",
    perDay: "في اليوم",
    finalNote: "يتم تأكيد السعر النهائي والتوفر عند الاستفسار.",
    noDepositYes: "مؤهلة للتأجير بدون وديعة (تطبق الشروط)",
    enquireVehicle: "استفسر عن هذه السيارة",
    whatsapp: "راسلنا واتساب",
    close: "إغلاق",
    drag: "اسحب للتدوير",
    gallery: "المعرض",
    view360: "عرض 360°",
    fullscreen: "ملء الشاشة",
    exitFullscreen: "إنهاء ملء الشاشة",
    availability: "التوفر",
    previous: "الصورة السابقة",
    next: "الصورة التالية",
  },
  nodeposit: {
    eyebrow: "تأجير مرن",
    title: "خيارات بدون وديعة متاحة",
    text: "استمتع بتجربة تأجير أكثر مرونة في دبي. تتوفر خيارات بدون وديعة على سيارات مختارة وتخضع لشروط مثل مدة الإيجار وملف السائق.",
    cta: "استكشف السيارات المؤهلة",
    note: "ينطبق على سيارات مختارة فقط. يتم تأكيد الأهلية والشروط أثناء الاستفسار.",
  },
  how: {
    eyebrow: "آلية العمل",
    title: "كيف نعمل",
    steps: [
      { t: "اختر سيارتك", d: "استكشف تشكيلتنا، من السيارات اليومية إلى الفاخرة والخارقة." },
      { t: "أرسل استفسارك", d: "أخبرنا بالسيارة المفضلة وتواريخ الإيجار." },
      { t: "أكّد حجزك", d: "يؤكد فريقنا التوفر والأسعار والمتطلبات والخطوات التالية." },
    ],
  },
  about: {
    eyebrow: "عن A&A MOTORS",
    title1: "أكثر من مجرد سيارة.",
    title2: "إنها أسلوب حياتك.",
    p1: "في A&A MOTORS، نؤمن بأن كل رحلة تستحق السيارة المناسبة.",
    p2: "سواء كنت تستكشف دبي، أو في رحلة عمل، أو تبحث عن سيارة يومية مريحة، أو مستعداً لتجربة سيارة عالية الأداء، رؤيتنا هي أن نجعل العثور على قيادتك القادمة بسيطاً ومرناً.",
    p3: "من الأساسيات اليومية إلى تجارب القيادة الاستثنائية، نبني علامة قائمة على الخيار والخدمة وحرية القيادة على طريقتك.",
  },
  trust: {
    eyebrow: "الثقة والشفافية",
    title: "احجز بثقة",
    items: [
      { t: "شروط إيجار واضحة", d: "تُشارك جميع الشروط كتابياً قبل تأكيد أي شيء." },
      { t: "أسعار شفافة", d: "بدون رسوم خفية — يتم تأكيد السعر النهائي عند الاستفسار." },
      { t: "ودائع حسب السيارة", d: "تعتمد خيارات الوديعة أو الإعفاء منها على السيارة المختارة." },
      { t: "دعم سريع الاستجابة", d: "تواصل معنا مباشرة عبر واتساب أو الهاتف بلغتك." },
      { t: "استفسارات مباشرة", d: "نموذج واحد أو رسالة واحدة — وفريقنا يتولى الباقي." },
    ],
  },
  faq: {
    eyebrow: "معلومات مفيدة",
    title: "الأسئلة الشائعة",
    items: [
      {
        q: "ما المستندات المطلوبة لاستئجار سيارة في دبي؟",
        a: "عادةً: رخصة قيادة سارية، وجواز سفر أو بطاقة هوية إماراتية، وبطاقة دفع. وقد يحتاج السياح إلى رخصة قيادة دولية حسب بلد الإصدار. تختلف المتطلبات حسب السيارة وحالة الإقامة — يؤكد فريقنا كل التفاصيل قبل الحجز.",
      },
      {
        q: "هل جواز السفر مطلوب؟",
        a: "يُطلب من السياح عادةً جواز السفر مع ختم الدخول أو التأشيرة، بينما يستخدم المقيمون بطاقة الهوية الإماراتية. تختلف المتطلبات ونؤكدها لكل حجز.",
      },
      {
        q: "هل رخصة القيادة السارية مطلوبة؟",
        a: "نعم، دائماً. وقد تُطلب رخصة قيادة دولية حسب بلد الإصدار. بعض السيارات عالية الأداء تشترط حداً أدنى للعمر أو مدة امتلاك الرخصة.",
      },
      {
        q: "هل تتوفر خيارات تأجير بدون وديعة؟",
        a: "نعم، على سيارات مختارة وبشروط محددة. تعتمد الأهلية على السيارة ومدة الإيجار وملف السائق — تواصل معنا للتحقق من سيارة معينة.",
      },
      {
        q: "هل يمكنني استئجار سيارة ليوم واحد؟",
        a: "نعم، يتوفر الإيجار اليومي للعديد من السيارات، وقد تنطبق حدود دنيا للإيجار على بعض الطرازات.",
      },
      {
        q: "هل يمكن توصيل السيارة إلى الفندق؟",
        a: "يمكن ترتيب التوصيل داخل دبي — إلى الفندق أو السكن أو المطار — عند الطلب، حسب السيارة والجدولة.",
      },
      {
        q: "كيف أتحقق من توفر السيارة؟",
        a: "أرسل استفساراً عبر النموذج أو واتساب مع تواريخك المفضلة؛ يؤكد فريقنا التوفر والسعر النهائي قبل أي حجز.",
      },
      {
        q: "ما شروط الإيجار والتأمين؟",
        a: "يشمل السعر عادةً تأميناً أساسياً. وتختلف مبالغ التحمل وحدود الكيلومترات وسياسات الوقود ورسوم سالك (البوابات) حسب السيارة. تُشارك جميع الشروط بشفافية قبل التأكيد.",
      },
    ],
  },
  form: {
    eyebrow: "استفسار حجز",
    title: "اطلب حجزاً",
    sub: "أخبرنا بما تريد قيادته ومتى. يرد فريقنا بالتوفر والسعر الدقيق والمتطلبات.",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    method: "طريقة التواصل المفضلة",
    methodWhatsapp: "واتساب",
    methodCall: "مكالمة هاتفية",
    methodEmail: "بريد إلكتروني",
    vehicle: "السيارة المطلوبة",
    vehicleAny: "أي سيارة / أريد نصيحة",
    pickup: "تاريخ الاستلام",
    return: "تاريخ الإرجاع",
    handover: "استلام أم توصيل",
    handoverPickup: "سأستلم السيارة بنفسي",
    handoverDelivery: "توصيل إليّ (فندق / سكن / مطار)",
    message: "رسالة إضافية",
    messagePh: "تفاصيل الرحلة، عنوان التوصيل، أسئلة…",
    submit: "اطلب حجزاً",
    sending: "جارٍ الإرسال…",
    success: "استفسارك جاهز — تم فتح واتساب بجميع التفاصيل. اضغط إرسال وسنرد عليك قريباً.",
    whatsappNote: "عند الإرسال يُفتح واتساب مع استفسارك — أسرع طريقة للوصول إلينا.",
    error: "حدث خطأ أثناء إرسال الاستفسار. حاول مرة أخرى أو تواصل معنا عبر واتساب.",
    errRequired: "هذا الحقل مطلوب",
    errEmail: "يرجى إدخال بريد إلكتروني صحيح",
    errDates: "يجب ألا يسبق تاريخ الإرجاع تاريخ الاستلام",
  },
  contact: {
    eyebrow: "تواصل",
    title: "تحدث معنا مباشرة",
    text: "أسرع طريقة للتحقق من التوفر والأسعار. نجيب على واتساب والهاتف.",
    whatsapp: "راسلنا واتساب",
    whatsappAlt: "واتساب — خط ثانٍ",
    callUs: "اتصل بنا",
    uae: "الإمارات",
    germany: "ألمانيا",
    uaeNote: "مكالمات هاتفية",
    germanyNote: "واتساب ومكالمات",
    copy: "نسخ",
    copied: "تم النسخ",
  },
  floating: {
    open: "خيارات التواصل",
    whatsapp: "راسلنا واتساب",
    whatsappAlt: "واتساب (خط ثانٍ)",
    callUae: "اتصل بالإمارات",
    callDe: "اتصل بألمانيا",
  },
  footer: {
    desc: "تأجير سيارات فاخر في دبي — من القيادات اليومية إلى التجارب الاستثنائية.",
    fleetTitle: "الأسطول",
    contactTitle: "التواصل",
    legalTitle: "قانوني",
    socialTitle: "تابعنا",
    privacy: "سياسة الخصوصية",
    terms: "الشروط والأحكام",
    cookies: "إعدادات ملفات الارتباط",
    impressum: "معلومات قانونية",
    rights: "جميع الحقوق محفوظة.",
    socialPlaceholder: "الحسابات الرسمية قريباً",
  },
  cookies: {
    text: "نستخدم تخزيناً أساسياً لحفظ تفضيل اللغة وتحليلات لتحسين الموقع. لا توجد ملفات إعلانية.",
    accept: "قبول",
    decline: "رفض",
  },
  legal: {
    privacyTitle: "سياسة الخصوصية",
    termsTitle: "الشروط والأحكام",
    impressumTitle: "معلومات قانونية",
    backHome: "العودة إلى الصفحة الرئيسية",
    impressumNote: "المعلومات القانونية لموقع A&A MOTORS. الحقول الموسومة بـ [سيتم توفيره] ستُستكمل فور توفر وثائق التسجيل الرسمية.",
    impressumFields: [
      "اسم العلامة / الشركة: A&A MOTORS",
      "المؤسسون / الممثلون القانونيون: Abadellh Aiouze · Amin Schmidt",
      "الموقع: دبي، الإمارات العربية المتحدة — العنوان المسجل الكامل: [سيتم توفيره]",
      "رقم الرخصة التجارية: [سيتم توفيره]",
      "الرقم الضريبي (TRN): [سيتم توفيره]",
      "المسؤولون عن المحتوى: Abadellh Aiouze · Amin Schmidt",
    ],
    privacySections: [
      { h: "البيانات التي نجمعها", p: "عند إرسال استفسار حجز، نعالج التفاصيل التي تقدمها — الاسم والبريد الإلكتروني ورقم الهاتف والسيارة المفضلة وتواريخ الإيجار — للرد على استفسارك فقط." },
      { h: "كيف نستخدمها", p: "تُستخدم بياناتك فقط لمعالجة استفسارك، ولإعداد عقد الإيجار إذا تم الحجز. لا نبيع بياناتك ولا نشاركها مع أطراف ثالثة لأغراض تسويقية." },
      { h: "التخزين والاحتفاظ", p: "تُخزن الاستفسارات بشكل آمن ويُحتفظ بها فقط للمدة اللازمة لمعالجة طلبك والوفاء بالالتزامات القانونية." },
      { h: "حقوقك", p: "يمكنك طلب الاطلاع على بياناتك الشخصية أو تصحيحها أو حذفها في أي وقت عبر واتساب أو الهاتف." },
    ],
    termsSections: [
      { h: "أحكام عامة", p: "تحكم هذه الشروط استخدام موقع A&A MOTORS. السيارات والتوفر والأسعار المعروضة محتوى تجريبي حتى يتم تأكيدها في اتفاقية إيجار فردية." },
      { h: "الاستفسارات والحجوزات", p: "إرسال الاستفسار لا يُنشئ حجزاً. لا يُبرم عقد الإيجار إلا بعد أن يؤكد فريقنا معك التوفر والسعر والمتطلبات." },
      { h: "السيارات والأسعار", p: "السيارات والمواصفات والأسعار المعروضة استرشادية. يتم إبلاغك بالشروط النهائية — بما فيها الوديعة والتأمين والكيلومترات ورسوم سالك — قبل الحجز." },
      { h: "المسؤولية", p: "نسعى للدقة لكن لا نضمن أن يكون محتوى الموقع كاملاً أو محدثاً في جميع الأوقات." },
    ],
  },
  admin: {
    login: "دخول الإدارة",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    signIn: "تسجيل الدخول",
    signingIn: "جارٍ الدخول…",
    loginError: "بيانات غير صحيحة أو محاولات كثيرة.",
    dashboard: "لوحة الأسطول",
    vehicles: "السيارات",
    enquiries: "الاستفسارات",
    logout: "تسجيل الخروج",
    addVehicle: "إضافة سيارة",
    edit: "تعديل",
    del: "حذف",
    save: "حفظ",
    cancel: "إلغاء",
    name: "الاسم",
    category: "الفئة",
    price: "السعر / اليوم (درهم، فارغ = عند الطلب)",
    seats: "مقاعد",
    transmission: "ناقل الحركة",
    availability: "التوفر",
    noDeposit: "مؤهلة بدون وديعة",
    image: "رابط الصورة",
    featured: "مميزة",
    status: "الحالة",
    empty: "لا توجد استفسارات بعد.",
    confirmDelete: "حذف هذه السيارة؟",
    dates: "التواريخ",
    message: "الرسالة",
    back: "العودة إلى الموقع",
    vehicleSaved: "تم حفظ السيارة",
    vehicleDeleted: "تم حذف السيارة",
    statusUpdated: "تم تحديث الحالة",
    newVehicle: "سيارة جديدة",
    editVehicle: "تعديل السيارة",
  },
};
